export enum PeriodicReviewOperation {
  NO_REVISION = "NO_REVISION",
  REVISION_NEEDED = "REVISION_NEEDED",
  ARCHIVE = "ARCHIVE"
}
